<template>
  <div>
    <b-card>
      <div>
        <div class="d-flex mb-2 justify-content-between align-items-center">
          <h3 class="mb-0">
            Certyfikacja {{ resolveCertificationKind(certificationData.kind) }}
          </h3>
          <b-button
            v-if="isAdmin"
            size="sm"
            variant="light"
            :to="`/certifications-terms/edit/${certificationData.id}`"
          >
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">Edytuj</span>
          </b-button>
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="certification-description"
          v-html="formatCertificationDescription(certificationData.description)"
        />
        <!-- eslint-enable -->
        <hr>
        <b-row>
          <b-col
            cols="12"
            lg="3"
            sm="6"
            class="mb-1"
          >
            <h5>Rodzaj</h5>
            <div>{{ resolveCertificationKind(certificationData.kind) }}</div>
          </b-col>
          <b-col
            cols="12"
            lg="3"
            sm="6"
            class="mb-1"
          >
            <h5>Dział</h5>
            <div>{{ resolveDepartments(certificationData.departments) }}</div>
          </b-col>
          <b-col
            cols="12"
            lg="3"
            sm="6"
            class="mb-1"
          >
            <h5>Data</h5>
            <div>{{ certificationData.date | date }}</div>
          </b-col>
          <b-col
            cols="12"
            lg="3"
            sm="6"
            class="mb-1"
          >
            <h5>Egzaminator</h5>
            <div>
              {{ certificationData.examiner.firstName }} {{ certificationData.examiner.lastName }}<br>
              <small><a :href="'mailto:' + certificationData.examiner.email">{{ certificationData.examiner.email }}</a></small>
            </div>
          </b-col>
          <b-col
            cols="12"
            lg="3"
            sm="6"
            class="mb-1"
          >
            <h5>Lokalizacja</h5>
            <div>{{ certificationData.localization }}</div>
          </b-col>
          <template v-if="isAdmin || isManager || isFordPoland">
            <b-col
              cols="12"
              lg="3"
              sm="6"
              class="mb-1"
            >
              <h5>Sloty</h5>
              <div>
                <span :class="certificationData.availableSlotsCount ? 'text-primary font-weight-bold' : 'text-warning font-weight-bold'">
                  {{ certificationData.takenSlotsCount }}
                </span>
                / {{ certificationData.slots ? certificationData.slots.length : 0 }}
              </div>
            </b-col>
            <b-col
              cols="12"
              lg="3"
              sm="6"
              class="mb-1"
            >
              <h5>Bezpłatna certyfikacja</h5>
              <div>{{ certificationData.isFree ? 'Tak' : 'Nie' }}</div>
            </b-col>
            <b-col
              cols="12"
              lg="3"
              sm="6"
              class="mb-1"
            >
              <h5>Koszt certyfikacji</h5>
              <div>{{ certificationData.priceInGrosze | priceInGrosze }} netto / os.</div>
            </b-col>
          </template>
          <b-col
            v-if="isAdmin || isFordPoland || isTrainer"
            cols="12"
            lg="3"
            sm="6"
            class="mb-1"
          >
            <h5>Status</h5>
            <b-badge
              pill
              :variant="`light-${resolveCertificationStatus(certificationData.status).variant}`"
            >
              {{ resolveCertificationStatus(certificationData.status).text.toUpperCase() }}
            </b-badge>
          </b-col>
          <b-col
            v-if="isAdmin || isFordPoland"
            cols="12"
            lg="3"
            sm="6"
            class="mb-1"
          >
            <h5>Dealerzy</h5>
            <div v-if="certificationData.dealers && certificationData.dealers.length">
              <b-badge
                v-for="dealer in certificationData.dealers"
                :key="dealer['@id']"
                pill
                variant="primary"
                class="mr-1 mb-1"
              >
                {{ dealer.name }}
              </b-badge>
            </div>
            <div v-else>
              -
            </div>
          </b-col>
        </b-row>

        <hr>
        <h3>Materiały informacyjne</h3>
        <training-courses-files
          v-if="certificationData.informationMaterials && certificationData.informationMaterials.length"
          :existing-files="certificationData.informationMaterials"
          class="mb-2"
        />
        <div
          v-else
          class="mb-2"
        >
          Brak materiałów informacyjnych do pobrania.
        </div>

        <template v-if="(isAdmin || isTrainer || isFordPoland) && certificationData.reportMaterials && certificationData.reportMaterials.length">
          <hr>
          <h3>Materiały raportowe</h3>
          <training-courses-files
            :existing-files="certificationData.reportMaterials"
            class="mb-2"
          />
        </template>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BButton,
} from 'bootstrap-vue'
import resolveDepartments from '@/helpers/resolveDepartments'
import resolveCertificationKind from '@/helpers/resolveCertificationKind'
import resolveCertificationStatus from '@/helpers/resolveCertificationStatus'
import normalizeCertificationDescriptionHtml from '@/helpers/certification/normalizeCertificationDescriptionHtml'
import nl2br from 'nl2br'
import TrainingCoursesFiles from '../training-courses/TrainingCoursesFiles.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BButton,
    TrainingCoursesFiles,
  },
  props: {
    certificationData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatCertificationDescription(description) {
      return normalizeCertificationDescriptionHtml(nl2br(description || ''))
    },
    resolveDepartments,
    resolveCertificationKind,
    resolveCertificationStatus,
  },
}
</script>

<style lang="scss" scoped>
.certification-description ::v-deep p {
  margin-bottom: 0;
}
</style>
